/**
 * T053: usePrompts Hook
 * Query hook for fetching prompts list with filters
 */

import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { listPrompts, type PromptFilters } from '@/services/prompts'
import { queryKeys } from '@/lib/query-keys'

export function usePrompts(filters?: PromptFilters) {
  return useQuery({
    queryKey: queryKeys.prompts.list(filters),
    queryFn: () => listPrompts(filters),
    placeholderData: keepPreviousData,
  })
}
